import { useState } from "react";

import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';

import { Box, Button, Divider, Tab, Tabs } from "@mui/material";

import { Add } from "@mui/icons-material";

import { AllProjects } from "../index";
import { useCapabilities } from "../../../hooks/useCapabilities";
import { useNavigation } from "../../../hooks/useNavigation";
import { clientTheme } from "../../../theme/clientTheme";

const projectCardVariant = clientTheme.layout?.projectCardVariant ?? "classic";

export const Projects = () => {

    const { isAllowedToAddProject } = useCapabilities();

    const { goToAddProject } = useNavigation();

    const [currentTab, setCurrentTab] = useState('all-projects');
    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    const tabs = [
        { value: 'all-projects', label: projectCardVariant === "modern" ? 'All Projects' : 'All PROJECTS' },
        { value: 'pinned',       label: projectCardVariant === "modern" ? 'Pinned'       : 'PINNED'       },
        { value: 'completed',    label: projectCardVariant === "modern" ? 'Completed'    : 'COMPLETED'    },
    ];

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <TabContext value={currentTab}>
                <Box display="flex" alignItems="center" alignContent="center">
                    <Tabs
                        value={currentTab}
                        onChange={handleChangeTab}
                        aria-label="Tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{ minHeight: 'auto' }}
                    >
                        {tabs.map((t) => (
                            <Tab
                                key={t.value}
                                sx={{ height: 'auto', minHeight: 'auto' }}
                                label={t.label}
                                value={t.value}
                            />
                        ))}
                    </Tabs>
                    <Box px={2} ml={'auto'}>
                        {isAllowedToAddProject && (
                            projectCardVariant === "modern" ? (
                                <Button
                                    variant="contained"
                                    startIcon={<Add />}
                                    onClick={() => goToAddProject({})}
                                    sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
                                >
                                    Add Project
                                </Button>
                            ) : (
                                <Button startIcon={<Add />} onClick={() => goToAddProject({})}>
                                    ADD PROJECT
                                </Button>
                            )
                        )}
                    </Box>
                </Box>
                <Divider />
                <Box flex={1} overflow="hidden" mt={2}>
                    <TabPanel value="all-projects" sx={{ p: 0, height: "100%" }}>
                        <AllProjects isPinned={false} isCompleted={false} />
                    </TabPanel>
                    <TabPanel value="pinned" sx={{ p: 0, height: "100%" }}>
                        <AllProjects isPinned={true} isCompleted={false} />
                    </TabPanel>
                    <TabPanel value="completed" sx={{ p: 0, height: "100%" }}>
                        <AllProjects isPinned={false} isCompleted={true} />
                    </TabPanel>
                    <TabPanel value="my-view" sx={{ p: 0, height: "100%" }}>
                        {/* <AllProjects /> */}
                    </TabPanel>
                    <TabPanel value="others" sx={{ p: 0, height: "100%" }}>
                        {/* <Others /> */}
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    )
}